const state = {
	alerts: [],
	snackbars: [],
}

const getters = {
	alerts(currentState) {
		return currentState.alerts
	},
	snackbars(currentState) {
		return currentState.snackbars
	},
}

const actions = {
	pushAlert({ commit }, notification) {
		commit('pushAlert', notification)
	},
	removeAlert({ commit }, i) {
		commit('removeAlert', i)
	},

	pushSnackbar({ commit }, message) {
		commit('pushSnackbar', message)
	},
	removeSnackbar({ commit }, i) {
		commit('removeSnackbar', i)
	},
}

const mutations = {
	pushAlert(currentState, notification) {
		currentState.alerts.push(notification)
	},
	removeAlert(currentState, i) {
		currentState.alerts.splice(i, 1)
	},
	pushSnackbar(currentState, message) {
		currentState.snackbars.push(message)
	},
	removeSnackbar(currentState, i) {
		currentState.snackbars.splice(i, 1)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
